import React, { useEffect } from "react";
import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";
import $ from "jquery";

class KoppelenDiscipline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    $("#cover-spin").show(0);

    // var model = { discipline: $("input[name=discipline]:checked").attr("id") };
    var model = {
      discipline: $("input[name=discipline]:checked").attr("id"),
      naam: $("input[name=discipline]:checked").next("label").text(),
    };

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "0a716b4a-f3a7-4891-8b06-2bc973c92a6a",
      CallBackFunctions.DisciplineSavedCallback,
      window.$catalog_management_units_token
    );
  }

  componentDidMount() {
    $("#koppelen_discipline_aan_gebied").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_DISCIPLINE,
        1,
        30,
        CallBackFunctions.DisciplineCallback,
        window.$catalog_management_units_token
      );
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="koppelen_discipline_aan_gebied"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Selecteer discipline</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <input type="search" className="modal-search" placeholder="" />
              <div className="modal-scroll">
                <div id="koppelen-discipline-grp" className="radio-grp" />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="area_discipline_save"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default KoppelenDiscipline;
